<template>
  <component :is="rootTag"
             class="state-manager">
    <slot v-bind="functionality" />
  </component>
</template>

<script>
export default {
  name: "StateManager",
  props: {
    value: {
      type: [String, Object],
      default: "default",
    },
    urlMode: {
      type: String,
      default: null,
    },
    rootTag: {
      type: String,
      default: "div",
    },
  },
  data () {
    return {
      stateHistory: [],
      registeredStates: [],
      hash: "",
    };
  },
  computed: {
    functionality () {
      return {
        setState: this.pushState,
        goBack: this.popState,
        payload: this.currentPayload,
        state: this.currentStateName,
        canGoBack: this.canGoBack,
      };
    },
    currentState () {
      return this.stateHistory[this.stateHistory.length - 1];
    },
    currentStateName () {
      let result = null;
      if ( typeof ( this.currentState ) === "object" ) {
        result = this.currentState.name;
      } else {
        result = this.currentState;
      }

      return result;
    },
    currentPayload () {
      const state = this.currentState;
      let result = null;

      if ( state && typeof ( state ) === "object" ) {
        result = state.payload;
      }

      return result;
    },
    canGoBack () {
      return this.stateHistory.length > 1;
    },
    isHashMode () {
      return this.urlMode && this.urlMode.toLowerCase() === "hash";
    },
  },
  provide () {
    return {
      manager: this,
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler ( val ) {
        if ( val ) {
          if ( typeof ( val ) === "object" ) {
            this.pushState( ...Object.values( val ) );
          } else {
            this.pushState( val );
          }
        }
      },
    },
    currentState: {
      deep: true,
      handler ( val ) {
        this.$emit( "input", val );
      },
    },
    hash ( val ) {
      if ( val && val !== this.currentStateName ) {
        this.pushState( val );
      }
    },
  },
  created () {
    window.addEventListener( "hashchange", this.updateHash );
    this.updateHash();
  },
  beforeDestroy () {
    window.removeEventListener( "hashchange", this.updateHash );
  },
  methods: {
    registerState ( name ) {
      if ( this.registeredStates.includes( name ) ) {
        throw new Error( `Duplicate state name: '${name}'` );
      }
      this.registeredStates.push( name );
    },
    deregisterState ( name ) {
      const index = this.registeredStates.findIndex( n => n === name );
      this.registeredStates.splice( index, 1 );
    },
    pushState ( state, payload ) {
      if ( this.stateHistory.length !== 0 && !this.registeredStates.includes( state ) ) {
        throw new Error( `Cannot navigate to unregisterd state: '${state}'` );
      }

      if ( state !== this.currentStateName || payload !== this.currentPayload ) {
        this.setHash( state );

        if ( payload !== null && payload !== undefined ) {
          this.stateHistory.push( {
            name: state,
            payload,
          } );
        } else {
          this.stateHistory.push( state );
        }
      }
    },
    popState () {
      if ( this.stateHistory.length > 1 ) {
        this.stateHistory.pop();
      }
    },
    updateHash () {
      if ( this.isHashMode ) {
        const { hash } = window.location;
        let result = null;

        if ( hash ) {
          result = hash.replace( "#", "" );
        }

        this.hash = result;
      }
    },
    setHash ( value ) {
      if ( this.isHashMode ) {
        if ( value === "default" ) {
          window.location.hash = "";
        } else {
          window.location.hash = value || "";
        }
      }
    },
  },
};
</script>
